import { createSlice } from "@reduxjs/toolkit";
import { LocalStoragePersistanceService } from "persist/LocalStorage";
import { UserState } from "state/types";

const initialState: UserState = {
  user: null,
  jwt: "",
  searchInput: ""
};
const localStore = new LocalStoragePersistanceService()
export const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      const { user, jwt } = action.payload;
      state.jwt = jwt;
      state.user = user;
      localStore.setItem('user', user)
      localStore.setItem('jwt', jwt)
    },
    setSearchInput: (state, action) => {
      const { value } = action.payload;
      state.searchInput = value;
    }
  },
});

// Actions
export const { setUserData, setSearchInput } = usersSlice.actions;

// Thunks

export const loginUser = (userInfo) => async (dispatch) => {
  console.log("INDISDE LOGIN USER");
  dispatch(setUserData(userInfo));
};

export const updateSearchInput = (value) => async (dispatch) => {
  dispatch(setSearchInput(value));
};

export default usersSlice.reducer;
